import { Component, OnInit, Output, EventEmitter, Input, HostListener, ElementRef } from '@angular/core';
import {  Subscription } from 'rxjs';
import { AutocompleteService } from '@apply4u/services/autocomplete.service';
import { AutoComplete } from '@apply4u/models/autocomplete';
import { IsAny, IsNotNull, IsNotNullOrEmpty } from '@apply4u/shared/helpers/common/type-safe-helpers';
import { KeyboardEvents } from '@apply4u/shared/constant/keyboard-event.constant';
import { SmartLocationAutocompleteConstant } from '@apply4u/shared/constant/smart-location-autocomplete.constant';
import { JobSearchService } from '@apply4u/services/search/job-search.service';
import { LoadingService } from '@apply4u/services/loading.service';
import { ToasterMessageService } from '@apply4u/services/toaster-message.service';
import { ContextService} from '@apply4u/services/context-service';

@Component({
  selector: 'app-smart-location-autocomplete',
  templateUrl: './smart-location-autocomplete.component.html',
  styleUrls: ['./smart-location-autocomplete.component.css']
})
export class SmartLocationAutocompleteComponent implements OnInit {
  AutoCompleteOptions: AutoComplete[];
  LastAutoCompleteSubscription: Subscription;
  IsSuggest: boolean = false;
  ArrowkeyLocation = -1;
  SearchLength: number = 0;
  LocationSelectedOption: AutoComplete = new AutoComplete();
  
  @Input() Classes:string;
  @Input() shouldDisplayPostCode: boolean = true;
  @Input() SearchKeywordLocation: string;
  @Input() LocationSelectionName: string = SmartLocationAutocompleteConstant.LocationSelectionName;
  @Input() LocationSelectionId: string = SmartLocationAutocompleteConstant.LocationSelectionId;
  @Input() PlaceHolder: string = SmartLocationAutocompleteConstant.Placeholder;
  @Input() ReadCurrentLocation: boolean = false;

  @Output() SearchKeywordLocationChanged: EventEmitter<string> = new EventEmitter<string>();
  @Output() LocationIdChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() OnLocationSelectionChanged: EventEmitter<AutoComplete> = new EventEmitter<AutoComplete>();
  @Output() OnLocationSelectedOption: EventEmitter<AutoComplete> = new EventEmitter<AutoComplete>();

  constructor(
    private autoCompleteService: AutocompleteService,
    private _elementRef: ElementRef,
    private jobSearchService: JobSearchService,
    private loadingService: LoadingService,
    private toasterService: ToasterMessageService,
    private contextService: ContextService) {}

  ngOnInit(): void {
  }

  LoadAutoCompleteResults(val): void {
    if (IsNotNull(this.LastAutoCompleteSubscription)) {
      this.LastAutoCompleteSubscription.unsubscribe();
    }

    this.LastAutoCompleteSubscription = this.autoCompleteService.getAutoComplete(val)
      .subscribe(results => {
        if (IsAny(results) && this.SearchLength > 1) {
          this.AutoCompleteOptions = results;
          this.IsSuggest = true;
          this.ArrowkeyLocation = -1;
        } else {
          this.AutoCompleteOptions = [];
          this.IsSuggest = false;
          this.ArrowkeyLocation = -1;
        }
      });
  }

  OnPasteText(e: any): void {
    let value = e.target.value;
    this.GetAutoComplete(value);
  }

  OnInput(e: any): void {
    let value = e.target.value;
    this.GetAutoComplete(value);
  }

  GetAutoComplete(value: string): void {
    this.LocationSelectedOption = new AutoComplete();

    this.LocationSelectedOption.Value = value;
    this.LocationSelectedOption.DisplayValue = value;
    this.LocationSelectedOption.Key = "";
    this.LocationSelectedOption.DefaultRadius = 0;
    this.LocationSelectedOption.Latitude = null;
    this.LocationSelectedOption.Longitude = null;

    this.OnLocationSelectedOption.emit(this.LocationSelectedOption);

    if (IsNotNullOrEmpty(value) && value.length > 1) {
      this.AutoCompleteOptions = [];
      this.SearchLength = value.length;
      this.LoadAutoCompleteResults(value);
    } else {
      this.IsSuggest = false;
      this.AutoCompleteOptions = [];
    }
  }

  OnkeyDown(event: any): void {
    if (event.key === 'Tab') {
      this.IsSuggest = false;
    } else if (event.keyCode === KeyboardEvents.ArrowDownKey && this.IsSuggest == true) {
      if (this.ArrowkeyLocation < this.AutoCompleteOptions.length - 1) {
        this.ArrowkeyLocation++;
      } else {
        this.ArrowkeyLocation = -1;
      }

      let option = this.AutoCompleteOptions[this.ArrowkeyLocation];

      this.SearchKeywordLocation = option.DisplayValue;
      this.SearchKeywordLocationChanged.emit(this.SearchKeywordLocation);
      this.LocationIdChanged.emit(IsNotNull(option.Key) ? parseInt(option.Key) : null);
    } else if (event.keyCode === KeyboardEvents.ArrowUpKey && this.IsSuggest == true) {
      if (this.ArrowkeyLocation > 0) {
        this.ArrowkeyLocation--;
      } else {
        this.ArrowkeyLocation = this.AutoCompleteOptions.length - 1;
      }

      let option = this.AutoCompleteOptions[this.ArrowkeyLocation];

      this.SearchKeywordLocation = option.DisplayValue;
      this.SearchKeywordLocationChanged.emit(this.SearchKeywordLocation);
      this.LocationIdChanged.emit(IsNotNull(option.Key) ? parseInt(option.Key) : null);
    } else if (event.keyCode === KeyboardEvents.EnterKey && this.IsSuggest == true) {
      let option = this.AutoCompleteOptions[this.ArrowkeyLocation];
      
      this.OnOptionSelected(option);
      this.ArrowkeyLocation = -1;
    }
  }

  OnOptionSelected(option: AutoComplete): void {
    this.SearchKeywordLocation = option.DisplayValue;
    this.LocationSelectedOption = option;
    this.SearchKeywordLocationChanged.emit(this.SearchKeywordLocation);
    this.LocationIdChanged.emit(IsNotNull(option.Key) ? parseInt(option.Key) : null);

    if (option.Key == "0") {
      option.Key = "";
    }

    this.OnLocationSelectedOption.emit(option);
    this.OnLocationSelectionChanged.emit(this.LocationSelectedOption);
    this.IsSuggest = false;
    this.AutoCompleteOptions = [];
  }

  OnSearchLocationChange(): void {
    this.LocationSelectedOption.DisplayValue = this.SearchKeywordLocation;
    this.OnLocationSelectionChanged.emit(this.LocationSelectedOption);
    this.SearchKeywordLocationChanged.emit(this.SearchKeywordLocation);
  }

  DisplayAutoCompleteResult(): void {
    if (IsAny(this.AutoCompleteOptions)) {
      this.IsSuggest = true;
    }
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    const isClickedInside = this._elementRef.nativeElement.contains(targetElement);

    if (!isClickedInside) {
      this.IsSuggest = false;
    }
  }

  OnClickGpsTargetIcon(): void {
    if (window.navigator && window.navigator.geolocation) {
      this.SearchKeywordLocation = "";
      this.loadingService.Show();
      window.navigator.geolocation.getCurrentPosition(position => {
        this.jobSearchService.GetLocationByLatLong(position.coords.latitude, position.coords.longitude).subscribe(result => {
          this.SearchKeywordLocation = result;
          this.OnSearchLocationChange();
        });
        this.loadingService.Hide();
      }, error=> {
        const message = `Please enable your location to search ${this.contextService.IsJobSeeker ? "jobs" : "CVs" } near you`;
        this.toasterService.Error(message,null);
      });           
      this.loadingService.Hide();
    };
  }

  
}
